import React from 'react'

import { MagnifyingGlassIcon } from '@application/Interfaces/Icons'
import { Button } from '@application/Interfaces/Molecules/Button'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

import { Link, Message, Wrapper } from './NoResult.styled'

type NoResultType = {
    message: string
    link: string
    linkLabel: string
    className?: string
    $mode?: ThemeModeType
}

export const NoResult = ({ message, link, linkLabel, className, $mode }: NoResultType): JSX.Element => (
    <Wrapper className={className}>
        <Grid container justifyContent="center" spacingTop={12}>
            <MagnifyingGlassIcon />
        </Grid>
        <Grid container justifyContent="center" spacingTop={12}>
            <Message>{message}</Message>
        </Grid>
        <Grid container justifyContent="center" spacingTop={6}>
            <Link to={link}>
                <Button mode={$mode}>{linkLabel}</Button>
            </Link>
        </Grid>
    </Wrapper>
)
